const t = "http://172.16.2.62:9999"; //http://172.16.2.76:8000 //http://172.17.1.38:8001
const p = "https://afacard.afa.pt:8000";
const Url = p;

const tAFACARD = "http://172.17.1.29:7000/api/v1";
const pAFACARD = "https://afacard.afa.pt:7654/api/v1";
const UrlAFACARD = pAFACARD;

var user = JSON.parse(localStorage.getItem("user"));

function setUser(newUser) {
  user = newUser;
  localStorage.setItem("user", JSON.stringify(newUser));
}

function getUser() {
  return user;
}

export { Url, UrlAFACARD, setUser, getUser };